
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/terms/privacy",
      function () {
        return require("private-next-pages/profile/terms/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/terms/privacy"])
      });
    }
  